import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

const Spinner = ({ classes, ...rest }) => {
  return (
    <div
      className={classNames({
        [classes.root]: true,
        [rest.className]: rest.className
      })}
    />
  );
};

Spinner.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.string,
  size: PropTypes.number.isRequired
};

Spinner.defaultProps = {
  size: 30
};

const styles = theme => ({
  "@keyframes clip": {
    "0%": {
      transform: "rotate(0deg) scale(1)"
    },
    "50%": {
      transform: "rotate(180deg) scale(0.8)"
    },
    "100%": {
      transform: "rotate(360deg) scale(1)"
    }
  },
  root: {
    background: "transparent",
    width: props => props.size,
    height: props => props.size,
    borderRadius: "100%",
    border: "2px solid",
    borderColor: props => props.color || theme.colors.primary[1],
    borderBottomColor: "transparent !important",
    display: "inline-block",
    animation: "clip 0.75s 0s infinite linear",
    animationFillMode: "both",
    cursor: "wait"
  }
});

export default injectSheet(styles)(Spinner);



// WEBPACK FOOTER //
// ./src/components/shared/Spinner.js